import axios from "axios";
export const API_URL = "/api/v1";
export const GET_PAYMENT_REPORT_LIST_URL = API_URL+"/payment_report/get_payment_report_list/";
export const GET_PAYMENT_REPORT_DETAIL_URL = API_URL+"/payment_report/get_payment_report_detail/";
export const UPDATE_PAYMENT_REPORT_URL = API_URL+"/payment_report/update_payment_report/";
export const GET_PAYMENT_REPORT_LIST_THIS_MONTH_URL = API_URL+"/payment_report/get_payment_report_list_this_month/";
export const GET_PAYMENT_REPORT_LIST_ALL_URL = API_URL+"/payment_report/get_payment_report_list_all/";


export function getPaymentReportList(params) {
  return axios.get(GET_PAYMENT_REPORT_LIST_URL + '?page='+ params.page + '&type=' + params.type + '&start_date=' + params.start_date + '&end_date='+params.end_date + '&company_name='+params.company_name + '&company_number='+params.company_number);
}

export function getPaymentReporDetail(params) {
  return axios.get(GET_PAYMENT_REPORT_DETAIL_URL + '?id='+ params.id);
}

export function updatePaymentReport(params) {
  return axios.post(UPDATE_PAYMENT_REPORT_URL, params);
}

export function getPaymentReportListThisMonth() {
  return axios.get(GET_PAYMENT_REPORT_LIST_THIS_MONTH_URL);
}

export function getPaymentReportListAll() {
  return axios.get(GET_PAYMENT_REPORT_LIST_ALL_URL);
}
